import AiForm from "@/components/AiForm";
import ResumeForm from "@/components/ResumeForm";
import Layout from "@/components/layout";
import { FC } from "react";
import Head from "next/head";
import { useRouter } from "next/router";

interface indexProps {}

const Index: FC<indexProps> = ({}) => {
  const router = useRouter();
  //add canonical tag
  const canonicalUrl = (
    `https://instantapply.co/resume-analyzer` +
    (router.asPath === "/" ? "" : router.asPath)
  ).split("?")[0];
  return (
    <>
      <Layout>
        <Head>
          <title>
            Unlock Your Career Potential with Our Free Resume Evaluation
          </title>
          <meta
            name="title"
            property="og:title"
            content="Unlock Your Career Potential with Our Free Resume Evaluation"
          />
          <meta
            name="keywords"
            content="resume analyzer, resume score, resume checker, ATS, job applications"
          />
          <meta
            name="description"
            content="Our cutting-edge online resume assessment tool harnesses AI technology to provide comprehensive feedback on your resume. Craft a standout resume that outperforms ATS filters and secures more job interviews."
          />
          <link rel="icon" href="/favicon.ico" />
          <link rel="canonical" href={canonicalUrl} key="canonical" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://instantapply.co" />
          <meta
            property="og:title"
            content="Unlock Your Career Potential with Our Free Resume Evaluation"
          />
          <meta
            name="description"
            property="og:description"
            content="Our cutting-edge online resume assessment tool harnesses AI technology to provide comprehensive feedback on your resume. Craft a standout resume that outperforms ATS filters and secures more job interviews."
          />
          <meta property="og:site_name" content="instantapply.co" />
          <meta
            name="image"
            property="og:image"
            content="https://yauoagpuebtzbgpptwsp.supabase.co/storage/v1/object/public/image/instantapply-image.png"
          />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content="https://instantapply.co" />
          <meta property="twitter:site" content="@instantapplyco" />
          <meta
            property="twitter:title"
            content="Unlock Your Career Potential with Our Free Resume Evaluation"
          />
          <meta
            property="twitter:description"
            content="Our cutting-edge online resume assessment tool harnesses AI technology to provide comprehensive feedback on your resume. Craft a standout resume that outperforms ATS filters and secures more job interviews."
          />
          <meta
            property="twitter:image"
            content="https://yauoagpuebtzbgpptwsp.supabase.co/storage/v1/object/public/image/instantapply-image.png"
          />
          <meta name="next-head-count" content="23" />
        </Head>
        <ResumeForm />
      </Layout>
    </>
  );
};

export default Index;
